import React from 'react';
import { Link, WorksAvatar } from '@common/components';
import PropTypes from 'prop-types';
import { Colors, Spacing } from 'works/legacy/lib/style-helper';

export function CandidateLink({ firstName, lastName, link, subText }) {
  const fullName = `${firstName} ${lastName}`;

  return (
    <>
      <Link to={link} className="CandidateLink sentry-mask">
        <div style={{ width: 48 }}>
          <WorksAvatar firstName={firstName} lastName={lastName} size={48} />
        </div>

        <div>
          <div className="CandidateLinkName">{fullName}</div>
          {subText && <div className="CandidateLinkSubtext">{subText}</div>}
        </div>

        <style jsx>{`
          :global(a.CandidateLink) {
            display: flex;
            align-items: center;
          }
          .CandidateLinkName,
          .CandidateLinkSubtext {
            margin: 0 ${Spacing.baseSpacing / 2}px;
          }
          .CandidateLinkName {
            font-size: 16px;
            color: ${Colors.elm};
            font-weight: 500;
          }
          .CandidateLinkSubtext {
            font-size: 11px;
          }
        `}</style>
      </Link>
    </>
  );
}

CandidateLink.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
  link: PropTypes.string.isRequired,
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
